import { render } from "./MenuIcon.vue?vue&type=template&id=6bc66f57"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__